import React, { memo } from 'react';
import ReactDOM from 'react-dom';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import styles from './datePicker.module.scss';
import './datePicker.scss';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import CustomLabel from '../CustomLabel';

const CustomDialog = ({ selected, label, placeholder, onChange, hideIcon, error, width, disableFuture = true   }) => {

    const { t } = useTranslation('date');
    const OverlayInBody = ({ children, input, ...props }) => {
        if (!input) return null;
        const rect = input.getBoundingClientRect();
      
        return ReactDOM.createPortal(
          <div
            {...props}
            style={{
              ...props.style,
              position: "absolute",
              top: rect.bottom + window.scrollY,
              left: rect.left + window.scrollX,
              zIndex: 9999,
            }}
          >
            {children}
          </div>,
          document.body
        );
      };
      
    return (
        <div className={styles.inputContent} style={width ? { width, minWidth: width } : undefined}>
            {
                (label) && <CustomLabel className={styles.label}> {label}</CustomLabel>
            }
            <div className={`${styles.inputWrapper} ${error ? styles.error : ''}`}>
                <DayPickerInput
                    dayPickerProps={{
                        months: t("date:months", { returnObjects: true }),
                        weekdaysShort: t("date:short_days", { returnObjects: true }),
                        ...(disableFuture ? { disabledDays: { after: new Date() } } : {}) 
                    }}
                    format="DD-MM-YYYY"
                    formatDate={(date) => moment(date).format("DD-MM-YYYY")}
                    parseDate={(str) => moment(str, "DD-MM-YYYY").toDate()}
                    //  onBlur={onChange}
                    onDayChange={onChange}
                    placeholder={placeholder}
                    value={selected ? moment(selected).format("DD-MM-YYYY") : ""}
                    inputProps={{
                        onKeyPress: (e) => {
                            const keyCode = e.keyCode || e.which;
                            const keyValue = String.fromCharCode(keyCode);
                            const isValid = /[0-9-]/.test(keyValue);
                            if (!isValid) {
                                e.preventDefault();
                            }
                        }
                    }}
                    overlayComponent={OverlayInBody} 
                />
                {!hideIcon && !error && <svg className={styles.calendarIcon} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 2H13C13.5523 2 14 2.44772 14 3V13C14 13.5523 13.5523 14 13 14H3C2.44772 14 2 13.5523 2 13V3C2 2.44772 2.44772 2 3 2H4M8 2H4M12 2H8M12 2V1M4 2V1" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
                    <path d="M2 5H14" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
                </svg>}
                {!hideIcon && error && <svg className={styles.alertIcon} width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 8V12M12 16H12.01M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="#ff4d4f" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>}
            </div>
        </div>
    )
}

export default memo(CustomDialog);